import { Dispatch, SetStateAction, useState } from 'react'
import { ILoginScreen } from '../Login'
import { Button, CircularProgress, TextField, Typography } from '@mui/material'
import { useSendTalentPasswordResetEmailMutation } from '../../../Redux/api/talentApi'
import { useToast } from '../../../Hooks/useToast'
import { useSendClientPasswordResetEmailMutation } from '../../../Redux/api/clientApi'
import { ProfileType } from '../../../Types/General'

interface IForgotPasswordProps {
    loginType: ProfileType | undefined
    setScreen: Dispatch<SetStateAction<ILoginScreen>>
}
export const ForgotPassword = ({loginType, setScreen}:IForgotPasswordProps ) => {
    /* ******************** Hooks ******************** */
    const { showToast } = useToast();
    const [sendTalentResetEmail, {data: talentResetResponse, isLoading: talentResetLoading}] = useSendTalentPasswordResetEmailMutation()
    const [sendClientResetEmail, {data: clientResetResponse, isLoading: clientResetLoading}] = useSendClientPasswordResetEmailMutation()
    /* ******************** Variables ******************** */
    const [email, setEmail] = useState('')
    /* ******************** Functions ******************** */
    const handleChange = (params: any) => {
        setEmail(params.target.value);
    }
    const handleClick = () => {
        if (loginType == ProfileType['Talent']) {
            sendTalentResetEmail({email})
            .unwrap()
            .then(res => setScreen(ILoginScreen['sent']))
            .catch(err => {
                console.log(err);
                showToast({
                    text: 'Error occured while sending email',
                    variant: 'error'
                })
            });  
        }      
        if (loginType == ProfileType['Client']) {
            sendClientResetEmail({email})
            .unwrap()
            .then(res => setScreen(ILoginScreen['sent']))
            .catch(err => {
                console.log(err);
                showToast({
                    text: 'Error occured while sending email',
                    variant: 'error'
                })
            });  
        }  
    }
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <>
            <Typography variant="body-large" marginBottom={"30px"}>Enter your email address</Typography>            
            <TextField
                value={email}
                onChange={handleChange}
                placeholder="Email address"
                sx={{
                    marginBottom: "16px",
                    width: "300px"
                }}
            />
            <Button 
                variant="contained" 
                disabled={email.length == 0} 
                size="large" 
                onClick={handleClick}
                endIcon={talentResetLoading || clientResetLoading? <CircularProgress color="secondary" size={"18px"}/> :null} 
            >
                {talentResetLoading || clientResetLoading? "Sending email..." : "Send email"}                
            </Button>
        </>
    )
}